import React, { useEffect } from 'react'
import Navbar from './Components/Navbar/Navbar'
import Hero from './Components/Hero/Hero'
import About from './Components/About/About'
import Services from './Components/Services/Services'
import MyWork from './Components/MyWork/MyWork'
import Contact from './Components/Contact/Contact'
import Footer from './Components/Footer/Footer'
import Experience from './Components/Experience/Experience'
import ThemeToggle from './Components/ThemeToggle'

const App = () => {

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "dark";
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  return (
    <div className="portfolio-root">
      <ThemeToggle />
      <Navbar />
      <Hero />
      <About />
      <MyWork />
      <Experience />
      <Services />
      <Contact />
      <Footer />
    </div>
  )
}

export default App